<template>
  <div id="canvasBox" :style="getHorizontalStyle">
    <div :class="{ greet: true, greet_row: degree === 0 }">
      <div class="greet_1">
        <span @click="backClick">
          &lt; {{ $t('onLinePharmacyDelivery.signatureBtn') }}</span
        >
        <div class="tip_">
          {{ $t('onLinePharmacyDelivery.signatureConfirm') }}
        </div>
        <!-- 按钮区 -->
        <div class="btnBox">
          <div class="btn" @click="clear()">
            {{ $t('onLinePharmacyDelivery.remove') }}
          </div>
          <div class="btn" @click="download()" style="color: #c7a283">
            {{ $t('onLinePharmacyDelivery.btnConfirm') }}
          </div>
        </div>
      </div>
    </div>
    <canvas style="background-color: #f5f5f5"></canvas>
  </div>
</template>
<script>
import Draw from '@/utils/draw'
export default {
  props: {
    localCount: {
      type: String,
      default: 'claimPage'
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      image: null,
      degree: 0 // 屏幕整体旋转的角度, 可取 -90,90,180等值
    }
  },
  inject: ['reload'],
  mounted() {
    this.canvasBox = document.getElementById('canvasBox')
    this.initCanvas()
    const evt = 'onorientationchange' in window ? 'orientationchange' : 'resize'
    const that = this
    window.addEventListener(
      evt,
      function () {
        setTimeout(function () {
          sessionStorage.setItem('reloadPage', 'reloadPage')
          that.reload()
          setTimeout(() => {
            sessionStorage.removeItem('reloadPage')
          }, 1000)
        }, 300)
      },
      false
    )
    const count = localStorage.getItem(`${this.localCount}`)
    if (count) {
      localStorage.removeItem(`${this.localCount}`)
      sessionStorage.setItem('reloadPage', 'reloadPage')
      this.reload()
      setTimeout(() => {
        sessionStorage.removeItem('reloadPage')
      }, 1000)
    }
  },
  computed: {
    // 签名横屏竖屏
    getHorizontalStyle() {
      const d = document
      const w =
        window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth
      const h =
        window.innerHeight ||
        d.documentElement.clientHeight ||
        d.body.clientHeight
      let length = 0
      let width = w
      let height = h

      if (width < height) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.degree = 90
        width = h
        height = w
        length = (width - height) / 2
      }
      if (this.canvasBox) {
        this.canvasBox.removeChild(document.querySelector('canvas'))
        this.canvasBox.appendChild(document.createElement('canvas'))
        this.$nextTick(() => {
          this.initCanvas()
        })
      }

      return {
        transform: `rotate(${this.degree}deg) translate(${length}px,${length}px)`,
        width: `${width}px`,
        height: `${height}px`,
        transformOrigin: 'center center'
      }
    }
  },
  methods: {
    // 初始化canvas
    initCanvas() {
      const canvas = document.querySelector('canvas')
      this.draw = new Draw(canvas, -this.degree)
    },
    // 返回
    backClick() {
      if (!this.data.imageUrl) {
        this.$toast(this.$t('onLinePharmacyDelivery.aftersign'))
        return false
      }
      this.$emit('compeletSign')
    },
    // 清除画布
    clear() {
      this.draw.clear()
    },
    // 生成签名图片
    download() {
      const canvas = document.querySelector('canvas')
      if (this.isCanvasDraw(canvas)) {
        this.$toast('请签名！')
        return false
      }
      const image = this.draw.getPNGImage()
      const file = this.draw.dataURLtoBlob(image)
      const formData = new FormData()
      formData.append('file', file)
      // 传的数据格式不同  因为是单独emit的方法不和其他组件公用
      this.$emit('compeletSign', formData)
    },
    // 判断是否有签名
    isCanvasDraw(canvas) {
      const a = document.createElement('canvas')
      a.width = canvas.width
      a.height = canvas.height
      return a.toDataURL() === canvas.toDataURL()
    }
  }
}
</script>
<style lang="scss" scoped>
#canvasBox {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: PingFang SC;
  background: #f0f0f0;
  font-size: 15px;
  transform-origin: center center;
}
$fontSize: 16px;
$fontSize_small: 12px;
.greet {
  font-size: $fontSize;
  user-select: none;
  white-space: nowrap;

  .greet_1 {
    line-height: 1.5;
    padding: $fontSize_small $fontSize_small * 2;
    display: flex;
    flex-wrap: nowrap;
    background: #fff;
    align-items: center;
    justify-content: space-between;
  }

  .tip_ {
    padding: 10px;
    font-size: $fontSize_small;
    color: #999999;
    line-height: 1.4;
    text-align: left;
    padding: 0 $fontSize * 2 0 $fontSize_small;
    white-space: normal;
  }
  .btnBox {
    box-sizing: border-box;
    display: flex;

    .btn {
      text-align: center;
      color: #999;
      line-height: 2.5;
      font-weight: bold;
      margin-left: 10px;
      border-radius: 4px;
    }
  }
}
.greet_row {
  font-size: $fontSize / 2;
  .greet_1 {
    padding: $fontSize_small / 2 $fontSize_small;
  }
  .tip_ {
    font-size: $fontSize_small / 2;
    padding: 0 $fontSize 0 $fontSize_small / 2;
  }
}

.greet a {
  cursor: pointer;
}

.greet select {
  font-size: 18px;
}

canvas {
  flex: 1;
  cursor: crosshair;
}
</style>
